import React from 'react';
import { ScrollReveal } from './ScrollReveal';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string | React.ReactNode;
  subtitle?: string;
  align?: 'left' | 'center';
  light?: boolean;
  className?: string;
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'left',
  light = false,
  className = ''
}: SectionHeadingProps) {
  const alignmentClass = align === 'center' ? 'text-center mx-auto' : 'text-left';
  const titleColor = light ? 'text-brand-cream-light' : 'text-brand-green-deep';
  const subtitleColor = light ? 'text-brand-cream/80' : 'text-brand-stone';
  return <div className={`max-w-3xl ${alignmentClass} ${className}`} data-id="element-446">
      {eyebrow && <ScrollReveal data-id="element-447">
          <span className="block text-brand-gold text-xs font-bold tracking-[0.2em] uppercase mb-4" data-id="element-448">
            {eyebrow}
          </span>
        </ScrollReveal>}

      <ScrollReveal delay={0.1} data-id="element-449">
        <h2 className={`text-4xl md:text-5xl lg:text-6xl font-heading leading-tight mb-6 ${titleColor}`} data-id="element-450">
          {title}
        </h2>
      </ScrollReveal>

      {subtitle && <ScrollReveal delay={0.2} data-id="element-451">
          <p className={`text-lg md:text-xl font-body leading-relaxed ${subtitleColor}`} data-id="element-452">
            {subtitle}
          </p>
        </ScrollReveal>}
    </div>;
}